import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { CustomInjector } from '../services/custom-injector/custom-injector';
import { ODataLTextModel, TextInputUtilities } from './text-input-utilities';

export class InternalInfoUtilities {
    private static log: LogInterface;
    public constructor() {
        const injector = CustomInjector.getInjector();
        InternalInfoUtilities.log = injector.get(LogInstanceToken);
    }

    public static getInfoLongTextById(response: ODataLTextModel[], textId: string): string {
        return TextInputUtilities.getLongtext(
            response.filter((line) => line.TextID === textId).sort((a, b) => (a.Counter < b.Counter ? -1 : 1)),
            '\n',
            this.log,
        );
    }
    /**
     * This method will filter the long text by ID
     *
     * @param response
     * @param textId
     */
    public static filterContactInfoById(response: ODataLTextModel[], textId: string): ODataLTextModel[] {
        return response
            .filter((contacts) => contacts.TextID === textId)
            .sort((a, b) => (a.Counter < b.Counter ? -1 : 1));
    }
}
